var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("div", { staticClass: "flex justify-between" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("documents")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-auto" },
          [
            _vm.invoicesRightPanelCollapsed
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toggleRightPanel(false)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("div", { staticStyle: { float: "right" } }, [
                          _c(
                            "svg",
                            {
                              staticClass: "hamburger",
                              staticStyle: { transform: "rotate(180deg)" },
                              attrs: {
                                viewBox: "0 0 1024 1024",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "17",
                                height: "17"
                              }
                            },
                            [
                              _c("path", {
                                staticStyle: {
                                  fill: "white",
                                  "verical-align": "middle !important"
                                },
                                attrs: {
                                  d:
                                    "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              : [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toggleRightPanel(true)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("div", { staticStyle: { float: "right" } }, [
                          _c(
                            "svg",
                            {
                              staticClass: "hamburger",
                              attrs: {
                                viewBox: "0 0 1024 1024",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "17",
                                height: "17"
                              }
                            },
                            [
                              _c("path", {
                                staticStyle: {
                                  fill: "white",
                                  "verical-align": "middle !important"
                                },
                                attrs: {
                                  d:
                                    "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.rightPanelLayoutVariables.mainPanelWidth } },
            [
              _c(
                "el-card",
                { staticClass: "invoices-card" },
                [
                  _c("invoice-table", {
                    attrs: {
                      view: "invoices",
                      "show-filters": true,
                      "props-sort": _vm.invoicesSort,
                      recipient: ""
                    },
                    on: {
                      "update:propsSort": function($event) {
                        _vm.invoicesSort = $event
                      },
                      "update:props-sort": function($event) {
                        _vm.invoicesSort = $event
                      },
                      highlightedChange: _vm.handleHighlightedChange
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: _vm.rightPanelLayoutVariables.rightPanelWidth } },
            [
              _vm.quickViewSelection !== null
                ? _c(
                    "div",
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix disp-flex",
                            attrs: { slot: "header" },
                            slot: "header"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "w-50 mt-5" },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    staticClass: "mr-10",
                                    attrs: {
                                      size: "mini",
                                      type: _vm._f("risoltoStatusFilter")(
                                        _vm.quickViewSelection.status
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$translate.invoice_status(
                                            _vm.quickViewSelection.status
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.quickViewSelection.document_number
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-50 text-right" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onViewDetail(
                                          _vm.quickViewSelection.reference,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("viewDetail")))]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.currentInvoice?.recipient &&
                        _vm.currentInvoice?.legal_entity
                          ? _c(
                              "div",
                              [
                                _c("actions-notes", {
                                  attrs: {
                                    recipient: _vm.currentInvoice.recipient,
                                    "legal-entity":
                                      _vm.currentInvoice.legal_entity
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("el-card", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("quickViewNotice", {
                                value: _vm.$t("anInvoice")
                              })
                            ) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }